import { useEffect, useState } from "react";
import { DarwinSpinner } from "./ui/DarwinSpinner";

export function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 10;
      });
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center">
        <div className="mb-6 mx-auto flex items-center justify-center">
          <DarwinSpinner size={72} />
        </div>
        <h2 className="mb-4">Analyzing Document</h2>
        <p className="text-muted-foreground mb-6">
          AI is scanning for sensitive information...
        </p>
        <div className="w-64 h-2 bg-muted rounded-full overflow-hidden mx-auto">
          <div
            className="h-full bg-primary transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-muted-foreground mt-2">{progress}%</p>
      </div>
    </div>
  );
}
